import { render, staticRenderFns } from "./p-header-style2.vue?vue&type=template&id=01ccb7cb&scoped=true"
import script from "./p-header-style2.vue?vue&type=script&lang=js"
export * from "./p-header-style2.vue?vue&type=script&lang=js"
import style0 from "./p-header-style2.vue?vue&type=style&index=0&id=01ccb7cb&prod&lang=css"
import style1 from "./p-header-style2.vue?vue&type=style&index=1&id=01ccb7cb&prod&lang=scss&scoped=true"
import style2 from "./p-header-style2.vue?vue&type=style&index=2&id=01ccb7cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ccb7cb",
  null
  
)

export default component.exports